import { createContext } from 'react';
/**
 * A React context that provides access to a SimpleFormIterator data (the total number of items) and mutators (add, reorder and remove).
 * Useful to create custom array input iterators.
 * @see {SimpleFormIterator}
 * @see {ArrayInput}
 */
export var SimpleFormIteratorContext = createContext(undefined);
//# sourceMappingURL=SimpleFormIteratorContext.js.map